import { createRouter, createWebHistory } from 'vue-router'
import { setupAuthGuard } from './guards'

// 布局组件
const AuthLayout = () => import('@/components/layout/AuthLayout.vue')
const MainLayout = () => import('@/components/layout/MainLayout.vue')

// 页面组件
const Login = () => import('@/views/Login.vue')
const Register = () => import('@/views/Register.vue')
const Dashboard = () => import('@/views/Dashboard.vue')
const Projects = () => import('@/views/Projects.vue')
const ProjectDetail = () => import('@/components/project/ProjectDetail.vue')
// const GenerationQueue = () => import('@/views/GenerationQueue.vue')
const GenerationSettings = () => import('@/views/GenerationSettings.vue')
const Publish = () => import('@/views/Publish.vue')
const APIKeys = () => import('@/views/APIKeys.vue')
const Settings = () => import('@/views/Settings.vue')
const CanvasList = () => import('@/views/canvas/CanvasList.vue')
const CanvasEditor = () => import('@/views/canvas/CanvasEditor.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: AuthLayout,
    meta: { requiresGuest: true },
    children: [
      {
        path: '',
        name: 'LoginPage',
        component: Login,
        props: {
          title: '欢迎回来',
          subtitle: '登录您的账户继续使用AI内容生成平台'
        }
      }
    ]
  },
  {
    path: '/register',
    name: 'Register',
    component: AuthLayout,
    meta: { requiresGuest: true },
    children: [
      {
        path: '',
        name: 'RegisterPage',
        component: Register,
        props: {
          title: '创建账户',
          subtitle: '加入AICG平台，开始您的AI内容创作之旅'
        }
      }
    ]
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardPage',
        component: Dashboard
      }
    ]
  },
  {
    path: '/projects',
    name: 'Projects',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'ProjectsPage',
        component: Projects
      },
      {
        path: ':projectId',
        name: 'ProjectDetail',
        component: ProjectDetail,
        props: true
      },
      {
        path: ':projectId/studio',
        name: 'ContentStudio',
        component: () => import('@/views/studio/ContentStudio.vue'),
        props: true
      },
      {
        path: ':projectId/director',
        name: 'DirectorEngine',
        component: () => import('@/views/studio/DirectorEngine.vue'),
        props: true
      },
      {
        path: ':projectId/chapters/:chapterId/movie-studio',
        name: 'MovieStudio',
        component: () => import('@/views/studio/MovieStudio.vue'),
        meta: { title: '电影工作室' },
        props: true
      }
    ]
  },
  {
    path: '/canvas',
    name: 'Canvas',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'CanvasList',
        component: CanvasList
      },
      {
        path: ':canvasId',
        name: 'CanvasEditor',
        component: CanvasEditor,
        props: true
      }
    ]
  },
  {
    path: '/generation',
    name: 'Generation',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'GenerationPage',
        component: () => import('@/views/VideoTasks.vue')
      }
    ]
  },
  {
    path: '/generation/settings',
    name: 'GenerationSettings',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'GenerationSettingsPage',
        component: GenerationSettings
      }
    ]
  },
  {
    path: '/bgm-management',
    name: 'BGMManagement',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'BGMManagementPage',
        component: () => import('@/views/BGMManagement.vue')
      }
    ]
  },
  {
    path: '/bilibili-accounts',
    name: 'BilibiliAccounts',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'BilibiliAccountsPage',
        component: () => import('@/views/BilibiliAccounts.vue')
      }
    ]
  },
  {
    path: '/publish',
    name: 'Publish',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'PublishPage',
        component: Publish
      }
    ]
  },
  {
    path: '/api-keys',
    name: 'APIKeys',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'APIKeysPage',
        component: APIKeys
      }
    ]
  },
  {
    path: '/settings',
    name: 'Settings',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'SettingsPage',
        component: Settings
      }
    ]
  }
]

// 星牛运营端（Colastar G-UI-3 追加）：四屏挂在 MainLayout 内，路由前缀 /xingniu，与后端 src/xingniu 同名隔离
routes.push({
  path: '/xingniu',
  component: MainLayout,
  meta: { requiresAuth: true },
  children: [
    { path: '', redirect: '/xingniu/templates' },
    { path: 'templates', name: 'XingniuTemplates', component: () => import('@/views/xingniu/XnTemplates.vue'), meta: { title: '星牛 · 模板' } },
    { path: 'runs', name: 'XingniuRuns', component: () => import('@/views/xingniu/XnRuns.vue'), meta: { title: '星牛 · 任务单' } },
    { path: 'runs/new', name: 'XingniuNewRun', component: () => import('@/views/xingniu/XnNewRun.vue'), meta: { title: '星牛 · 新建任务' } },
    { path: 'runs/:id', name: 'XingniuRunDetail', component: () => import('@/views/xingniu/XnRunDetail.vue'), meta: { title: '星牛 · 看片判定' } }
  ]
})
import opsRoutes from './ops' // 星牛 /ops 运营端（Colastar G-UI-6 追加）：独立布局与守卫，见 router/ops/index.js
routes.push(...opsRoutes)
import xingniuAdminRoutes from './xingniu/admin' // 星牛管理端 /xingniu/admin（Colastar G-UI-8 追加）：AICON 壳内三页，见 router/xingniu/admin.js
routes.push(...xingniuAdminRoutes)

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 设置路由守卫
setupAuthGuard(router)

export default router
